function Stack() {
  const list = [];
  Object.defineProperty(this, 'list', { value: list });
}

Object.defineProperties(Stack.prototype, {
  empty: {
    get() { return this.list.length <= 0 }
  },
  peek: {
    get() { if (!this.empty) return this.list[this.list.length - 1] }
  },
  pop: {
    value() { return this.list.pop() }
  },
  push: {
    value(item) { return (this.list.push(item), this) }
  }
});

export default Stack;
